import { gql } from '@apollo/client'
import { SABRE_PACKAGING_FRAGMENT } from '../fragments'

export const SABRE_GET_PACKAGING = gql`
  query GetPackaging($input: PackagingQueryInput) {
    packaging(input: $input) {
      count
      hasMore
      results {
        ...Packaging
      }
    }
  }
  ${SABRE_PACKAGING_FRAGMENT}
`
